import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AutoSaveTextField from '../../AutoSaveTextField';

const UpdateDescriptionInputComponent = ({ value, disabled, handleUpdate, onFormChange }) => {
    const { t } = useTranslation();

    const [isError, setIsError] = useState(false);

    const handleBlur = event => {
        const newValue = event.target.value;
        const isEmpty = !newValue?.trim();

        if (isEmpty !== isError) {
            setIsError(isEmpty);
        }

        if (isEmpty) {
            onFormChange?.({ description: '' });
            return;
        }

        handleUpdate('basicInformation', {
            basicInformation: {
                description: newValue,
            },
        });
    };

    return (
        <AutoSaveTextField
            required
            error={isError || !value?.trim()}
            value={value}
            disabled={disabled}
            label={t('report.form.description')}
            rows={2}
            onBlur={handleBlur}
            multiline
            fullWidth
        />
    );
};

const UpdateDescriptionInput = memo(UpdateDescriptionInputComponent);

export default UpdateDescriptionInput;
